var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pendingCount > 0)?_c('div',{staticClass:"box right-side"},[(_vm.pendingCount > 0)?_c('div',[_vm._v(" View or update "),_c('router-link',{attrs:{"to":{ name: 'ViewPending' }}},[_vm._v(" "+_vm._s(_vm.pendingCount)+" event"),(_vm.pendingCount > 1)?_c('span',[_vm._v("s")]):_vm._e()]),_vm._v(" pending approval ")],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }